import { Link } from "react-router-dom";
import { useMemo, useState } from "react";
import { Filter, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useApi } from "@/modules/collector_v2/hooks/useApi";
import { PageHeader } from "@/modules/collector_v2/components/common/PageHeader";
import { LoadingState } from "@/modules/collector_v2/components/common/LoadingState";
import { ErrorState } from "@/modules/collector_v2/components/common/ErrorState";
import { EmptyState } from "@/modules/collector_v2/components/common/EmptyState";
import { RiskBadge } from "@/modules/collector_v2/components/common/RiskBadge";
import { SignalBadge } from "@/modules/collector_v2/components/common/SignalBadge";

function AlertsTable({ alerts }) {
  return (
    <Card data-testid="alerts-table-card"><CardContent className="pt-6">
      <Table data-testid="alerts-table" aria-label="Tabla de alertas">
        <TableHeader><TableRow><TableHead>Severidad</TableHead><TableHead>Tipo</TableHead><TableHead>Mano</TableHead><TableHead>Explicación</TableHead></TableRow></TableHeader>
        <TableBody>{alerts.map((alert) => (
          <TableRow key={alert.alert_id} data-testid="alerts-table-row"><TableCell><RiskBadge level={alert.severity === "critical" ? "critical" : alert.severity === "high" ? "high" : alert.severity === "medium" ? "medium" : "low"} testid="alerts-severity-badge" /></TableCell><TableCell><SignalBadge type={alert.type} /></TableCell><TableCell className="mono"><Link to={`/manos/${encodeURIComponent(alert.hand_id)}`}>{alert.hand_id}</Link></TableCell><TableCell><strong>{alert.title}</strong><p className="muted-text">{alert.explanation}</p></TableCell></TableRow>
        ))}</TableBody>
      </Table>
    </CardContent></Card>
  );
}

export default function AlertsPage() {
  const [q, setQ] = useState("");
  const query = useMemo(() => `/alerts${q.trim() ? `?q=${encodeURIComponent(q.trim())}` : ""}`, [q]);
  const { data, loading, error, refetch } = useApi(query, [query]);
  const alerts = data?.items || [];
  return (
    <>
      <PageHeader eyebrow="Señales" title="Alertas explicadas" description="Cada alerta incluye categoría, severidad, evidencia y link a la mano." />
      <Card className="filter-card"><CardContent className="filter-content"><div className="filter-input"><Filter className="h-4 w-4" /><Input data-testid="alerts-search-input" value={q} onChange={(event) => setQ(event.target.value)} placeholder="Buscar alerta, handId o explicación" /></div><Button data-testid="alerts-refresh-button" variant="outline" onClick={refetch}>Refrescar</Button></CardContent></Card>
      {loading && <LoadingState />}
      {error && <ErrorState message={error} onRetry={refetch} />}
      {!loading && !error && alerts.length === 0 && <EmptyState title="Sin alertas" description="Cuando el motor detecte señales, aparecerán acá con evidencia." icon={ShieldAlert} testid="alerts-empty-state" />}
      {!loading && !error && alerts.length > 0 && <AlertsTable alerts={alerts} />}
    </>
  );
}
